import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Theme first (synced at build time by scripts/sync-theme.sh from web_themes),
// then App.css so app rules override.
import './styles/theme/index.css';
import './styles/theme/theme.css';
import './App.css';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
